// @flow
import React from 'react';
import type { Node } from 'react';
import styled, { type StyledComponent } from 'styled-components';

import CalloutBadgeStyle from './CalloutBadge.constants';

type StyledBadgeProps = {
  calloutBadgeStyle: CalloutBadgeStyle,
};

const Badge: StyledComponent<StyledBadgeProps> = styled.span`
  ${props => props.calloutBadgeStyle.toString()};
`;

export type Props = {
  value: Node,
  calloutBadgeStyle: CalloutBadgeStyle,
};

const CalloutBadge = ({ value, ...other }: Props): Node => <Badge {...other}>{value}</Badge>;

CalloutBadge.defaultProps = {
  calloutBadgeStyle: CalloutBadgeStyle.DEFAULT,
};

CalloutBadge.Styles = CalloutBadgeStyle;

export default CalloutBadge;



// WEBPACK FOOTER //
// ../react-lib/src/components/callouts/CalloutBadge/CalloutBadge.jsx